import { FC } from 'react';

import { useInterval } from 'hooks';
import { STATUS_UPDATE_INTERVAL } from 'modules/onboarding/common/constants';

import { LegalClientSigningDocuments } from '../components';
import { useOnboardingContext } from '../hooks/useOnboardingContext';
import { PageComponentProps } from '../types';

export const LegalClientSigningDocumentsStep: FC<PageComponentProps> = () => {
  const { data } = useOnboardingContext();

  useInterval(data.refetchLegalClient, STATUS_UPDATE_INTERVAL);

  return <LegalClientSigningDocuments />;
};
